module.exports = __webpack_public_path__ + "static/centia300-fa7432d814c5df8545a316dd06a28870.png";